import { TextMidd } from '../../../../ui/Text'
import type { TabType } from '../../WorkspaceSettingsModal.tsx'
import css from './WorkspaceSettingsNavigation.module.css'

interface WorkspaceSettingsNavigationProps {
    options: { label: string; tab: TabType }[]
    activeTab: TabType
    onTabChange: (tab: TabType) => void
}

const WorkspaceSettingsNavigation = ({ options, activeTab, onTabChange }: WorkspaceSettingsNavigationProps) => {
    const getClassName = (tab: TabType) =>
        [css.item, activeTab === tab ? css.active : ''].filter(Boolean).join(' ')

    return (
        <div className={css.container}>
            {options.map(({ label, tab }) => (
                <div key={tab} className={getClassName(tab)} onClick={() => onTabChange(tab)}>
                    <TextMidd>{label}</TextMidd>
                </div>
            ))}
        </div>
    )
}

export default WorkspaceSettingsNavigation
